/**
 * One row per dial: the name, the two end labels, the line under the
 * name, and one example at each end. Stops 2, 3 and 4 have no lines.
 * Pace ends are Fast-forward and Every move.
 */
import {
  DIAL_BOOKISH,
  DIAL_CLOSE,
  DIAL_CLOSENESS,
  DIAL_EVERYDAY,
  DIAL_EVERY_MOVE,
  DIAL_FAR,
  DIAL_FAST_FORWARD,
  DIAL_LONG,
  DIAL_PACE,
  DIAL_SENTENCE_LENGTH,
  DIAL_SHORT,
  DIAL_WORD_CHOICE,
} from './writerCopy';

export const DIAL_EXPLAINERS = [
  {
    key: 'closeness',
    label: DIAL_CLOSENESS,
    low: DIAL_FAR,
    high: DIAL_CLOSE,
    description: "How close the reader gets to a character's thoughts.",
    lowExample: 'The frog let the scorpion climb on.',
    highExample: "Don't look back. Just keep kicking.",
  },
  {
    key: 'pace',
    label: DIAL_PACE,
    low: DIAL_FAST_FORWARD,
    high: DIAL_EVERY_MOVE,
    description: 'How fast events go by, from quick skips to every move shown.',
    lowExample: 'By noon they were halfway across.',
    highExample: 'It kicked, then felt the tail shift.',
  },
  {
    key: 'sentences',
    label: DIAL_SENTENCE_LENGTH,
    low: DIAL_SHORT,
    high: DIAL_LONG,
    description: 'Whether sentences run short and plain or long and winding.',
    lowExample: 'The frog swam. The sky went gray.',
    highExample: 'The frog swam on while the sky grayed and the bank slid away.',
  },
  {
    key: 'words',
    label: DIAL_WORD_CHOICE,
    low: DIAL_EVERYDAY,
    high: DIAL_BOOKISH,
    description: 'Whether the words are everyday or formal and old-fashioned.',
    lowExample: 'The water was cold and dark.',
    highExample: 'The river ran chill and fathomless.',
  },
];

export function dialExplainer(key, rows = DIAL_EXPLAINERS) {
  return rows.find((row) => row.key === key) || null;
}
